import { useTranslation } from "react-i18next";
import heroImage from "../../imgs/four_two.jpg"; 

function HeroComponent() {
  const { t } = useTranslation();

  return (
    <div
      className="relative min-h-[75vh] md:min-h-screen flex flex-col justify-end items-center text-center overflow-hidden"
      id="home"
    >
      {/* Background Layer */}
      <div className="fixed inset-0 z-[-10]">
        <img
          src={heroImage}
          alt="LiveTheWill band performing"
          /* Using object-cover to fill the screen (no black bars).
             Using object-center to keep the middle of the photo visible.
             Change 'object-center' to 'object-[50%_20%]' if you need to 
             shift the image up to see faces better.
          */
          className="w-full h-full object-cover object-center"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "https://placehold.co/1920x1080/2D3748/FFFFFF?text=Image+Unavailable";
          }}
        />
        {/* The Overlay: Darkens the image so text stays readable */}
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content Layer */}
      <div className="relative z-20 p-8 pb-20 sm:p-12 md:p-16 lg:p-20 text-white max-w-4xl mx-auto">
        <h1
          className="alt-font text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-4"
          style={{ textShadow: "2px 2px 10px rgba(0,0,0,0.9)" }}
        >
          LiveTheWill
        </h1>
        
        <div className="space-y-4 bg-black/20 backdrop-blur-[2px] p-4 rounded-xl">
          <p className="text-lg sm:text-xl md:text-2xl leading-relaxed">
            {t("hero.firstP", "We write and perform music to spread")}
          </p>

          <p className="text-md sm:text-lg md:text-xl italic">
            {t("hero.secondP", "Our inspiration flows from")}
            <a
              href="https://www.biblegateway.com/passage/?search=1+Petrus+4%3A1-11&version=ESV"
              target="_blank"
              rel="noopener noreferrer"
              className="underline decoration-white/30 hover:text-gray-300 transition-colors duration-200 font-semibold ml-2"
            >
              {t("hero.inspiration", " 1 Petrus 4:1-11 ")}
            </a>
            <span className="block mt-2 sm:inline sm:mt-0">
              {t(
                "hero.inspirationText",
                " - using the gifts He provides to serve others and bring Him glory through Jesus Christ."
              )}
            </span>
          </p>

          <p className="text-sm sm:text-lg font-medium pt-4">
            {t("hero.joinJourney", "Join our journey:")}
            <a
              href="https://www.instagram.com/LiveTheWill"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-gray-300 transition-colors duration-200 font-semibold ml-2 border-b border-white/40 pb-1"
            >
              Instagram @LiveTheWill
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default HeroComponent;